import { http } from "@/api";

const Qs = require("qs");

/**
 * Solicita os últimos pontos de cada particulado de óleo.
 * @param {Number} monitoringElementId Id do elemento de monitoramento tipo unidade geradora.
 * @returns Objecto com o último ponto de coletado de cada partícula.
 */
const GetParticles = function(monitoringElementId)
{
	return http.get(`/WindOilAnalysis/LastTrendRecords/${monitoringElementId}`);
};

/**
 * Solicita os pontos dos particulados de óleo para um determinado período.
 * @param {Object} parameters Parâmetros da requisição.
 * @returns Objecto com os pontos no período selecionado de cada partícula.
 */
const GetTrendParticles = function(parameters)
{
	return http.get(`WindOilAnalysis/TrendWindOilChart/${parameters.monitoringElementId}`, {
		params:           parameters,
		paramsSerializer: params => Qs.stringify(params, { arrayFormat: "repeat" }),
	});
};

export default
{ GetParticles, GetTrendParticles };